import _ from 'lodash';
export const convertTree = (data) => {
    const tmpObj = {},
        result = [];
    if (!data) return result;

    const cloneData = _.cloneDeep(data);
    const length = cloneData.length;

    for (let i = 0, len = length; i < len; i++) {
        const item = cloneData[i];
        tmpObj[item['id']] = item;
    }
    for (let i = 0, len = length; i < len; i++) {
        const child = cloneData[i],
            parent = tmpObj[child['parent_id']];
        if (parent) {
            parent['children'] = parent['children'] || [];
            parent['children'].push(child);
        } else {
            result.push(child);
        }
    }
    return result;
};
export const sortTreeData = (data) => data.sort((a, b) => a.sort - b.sort);
